import { UserAvatar } from "@/components/core/UserAvatar";
import { useAuth } from "@/contexts/AuthContext";

export function UserProfile() {
  const { user } = useAuth();

  const { displayName, email, photoURL } = user || {};

  return (
    <div className="flex items-center gap-2">
      <UserAvatar
        size="sm"
        name={displayName || ""}
        imageUrl={photoURL}
        className="rounded-full"
        fallbackClassName="bg-primary text-primary-foreground text-sm p-2"
      />

      <div className="flex flex-col truncate">
        <p className="text-sm font-medium truncate">{displayName || ""}</p>
        <p className="text-xs text-muted-foreground/60 truncate">{email || ""}</p>
      </div>
    </div>
  );
}